<template>
    <article-category-create-edit-form />
</template>

<script>
import ArticleCategoryCreateEditForm from './components/ArticleCategoryCreateEditForm.vue';
export default {
    components:{
        ArticleCategoryCreateEditForm
    }
}
</script>